/* eslint-disable */
import React from 'react'
import CalculateHitLocation from '../../Utilities/CalculateHitLocation'
import Color from '../../Utilities/Colors/ColorMap.ts'
import Legend from '../../Legend/Legend.tsx'
import Tooltip from '../../Tooltip/Tooltip.ts'
import { useTooltip } from '../../Context/ChartContext.tsx'

export default function Spray({ settings, chartOptions = {} }) {
    const { tooltipRef } = useTooltip()
    // Remove null spray
    let sprayData = settings.data

    // Set data to property in data set
    if (chartOptions.linkedDataProperty) {
        sprayData = settings.data[chartOptions.linkedDataProperty]
    }

    function handleMouseOver(event, tip) {
        debugger
        Tooltip(event, settings, tooltipRef.current, tip)
    }

    function handleMouseOut(event) {
        Tooltip(event, settings, tooltipRef.current)
    }


    return (
        <>
            <g id="sprayChart">
                {sprayData.map((d, i) => {
                    const coords = { x: d.x, y: d.y }
                    return (
                        <circle
                            id={`sprayChart_${d.id || i}`}
                            key={`pitch_${i}`}
                            cx={
                                CalculateHitLocation(
                                    coords,
                                    settings.vizWidth,
                                    settings.vizHeight
                                ).x
                            }
                            cy={
                                CalculateHitLocation(
                                    coords,
                                    settings.vizWidth,
                                    settings.vizHeight
                                ).y
                            }
                            r={chartOptions.radius || 4 / settings.vizScale}
                            fill={
                                chartOptions.color ||
                                Color(
                                    chartOptions.legendType,
                                    d[chartOptions.legendType]
                                )
                            }
                            opacity={chartOptions.opacity || 1}
                            stroke="black"
                            style={{
                                cursor: d.videoUrl ? 'pointer' : 'default',
                            }}
                            onMouseOver={(event) => {
                                const html = d.tooltip
                                if (html) {
                                    handleMouseOver(event, html)
                                }
                            }}
                            onMouseOut={(event) => {
                                const html = d.tooltip
                                if (html) {
                                    handleMouseOut(event, d)
                                }
                            }}
                            onClick={() => {
                                if (d.videoUrl) {
                                    window.open(d.videoUrl)
                                }
                            }}
                        />
                    )
                })}
            </g>
            {chartOptions.legend ? (
                <Legend settings={settings} type={chartOptions.legendType} />
            ) : null}
        </>
    )
}
